import BaseService from '@/services/base.service'
import { auth, db } from '@/config/firebase'
import { collection, doc, getDoc, getDocs, limit, orderBy, query, where } from 'firebase/firestore'
import PermissionEnum from '@/enums/permission.enum'

export default class AclService extends BaseService {
  public async checkAndGetPermissionFromUser(permission: string) {
    const [userMaxLevel, isSuperAdmin] = await Promise.all([
      this.getUserMaxLevel(),
      this.isUserSuperAdmin()
    ])

    if (isSuperAdmin) {
      return {
        type: PermissionEnum.ORGANIZATION,
        is_super_admin: isSuperAdmin
      }
    }

    const docSnap = (await getDoc(doc(this.getOrganizationRef(), 'acls', userMaxLevel)))?.get(
      'permissions'
    ) as { name: string; type: string }[]
    const permissionData = docSnap?.find((p) => p?.name === permission)
    return {
      ...permissionData,
      is_super_admin: isSuperAdmin
    }
  }

  public async getUserMaxLevel() {
    const user = auth.currentUser?.email
    const q = query(
      this.getCollectionPath('people', true),
      where('email', '==', user),
      where('organization_id', '==', this.organizationId),
      limit(1),
      orderBy('level', 'desc')
    )
    return (await getDocs(q))?.docs?.[0]?.get('level')
  }

  public async isUserSuperAdmin() {
    const userEmail = auth.currentUser?.email
    const q = query(collection(db, 'users'), where('email', '==', userEmail), limit(1))
    return (await getDocs(q))?.docs?.[0]?.get('is_super_admin')
  }
}
